import { useState } from 'react';
import Header from "../components/Header"
import Login from "../components/Login"

export default function LoginPage(){
    const [toastErrorOpen, setToastErrorOpen] = useState(false);
    const [toastErrorMsg, setToastErrorMsg] = useState('');

    return(
        <>
            <div className="min-h-full h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
                <div className="max-w-md w-full space-y-8">
                    <Header
                        heading="Kingpin — Security Operations Platform"
                        toastErrorOpen={toastErrorOpen}
                        setToastErrorOpen={setToastErrorOpen}
                        toastErrorMsg={toastErrorMsg}
                        />
                    <Login setToastErrorOpen={setToastErrorOpen} setToastErrorMsg={setToastErrorMsg} />
                    
                    <div className="text-center mt-8">
                        <p className="text-xs text-gray-400 dark:text-gray-500 font-mono">
                            © 2026 Mindcore OÜ. All rights reserved. v{process.env.REACT_APP_VERSION || '2.1.0'}
                        </p>
                    </div>
                </div> 
            </div>
        </>
    )
}